import { render } from "./ReviewerGuidelines.vue?vue&type=template&id=c26f244a"
import script from "./ReviewerGuidelines.vue?vue&type=script&lang=js"
export * from "./ReviewerGuidelines.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__